<template>
<div class="contact">
  <div class="content">
    <div class="pic">
      <img src="../../assets/logo-01.png" alt="">
    </div>
    <p>上海昊楼信息科技有限公司通过互联网与地产的行业经验与先进技术，致力于推动不动产领域的数字化经营管理系统建设。公司核心团队来自一线地产软件和互联网企业，产品既有专业管理软件的深度，也有着互联网产品的良好体验。</p>
    <p>“1号楼”系列产品包括“资管云” 、“运营云”、“招商云”、“决策云”、“物管云”、“IoT中心”等，全面支持商办空间、产业园区、写字楼、共享办公、购物中心、长租公寓等存量领域核心业态。存量时代，“1号楼”将帮助您的不动产数智化水平更上一层楼！</p>
  </div>
  <dl>
		<dd>上海总部地址:上海市浦东新区郭守敬路498号13号楼13502-13504室</dd>
		<dd>北京公司地址:北京市朝阳区北三环东路30号中国建筑科学研究院B座9楼</dd>
		<dd>广东公司地址:广州市天河区东莞庄路110号中创汇赛宝科技园206号楼</dd>
		<dd style="margin-bottom: 5px;">全国统一联系电话：021-80270017</dd>
		<dd>联系邮箱：market@1hello.com</dd>
  </dl>
  <button type="button" class="trial-button" @click="trialFlag = !trialFlag">我要试用</button>
  <div class="messge" v-if="trialFlag" @click="trialFlag = !trialFlag"></div>
  <div class="carry" v-if="trialFlag">
    <div class="colse" @click="trialFlag = !trialFlag">x</div>
    <h3>试用申请</h3>
    <ul>
      <li><input type="text" @focus="inpFocus" @blur="inpBlur" placeholder="请输入您的姓名" v-model="data.name"></li>
      <li><input type="text" @focus="inpFocus" @blur="inpBlur" placeholder="请输入您的电话" v-model="data.phone"></li>
      <li><input type="text" @focus="inpFocus" @blur="inpBlur" placeholder="请输入您的公司" v-model="data.company"></li>
      <li><input type="text" @focus="inpFocus" @blur="inpBlur" placeholder="请输入您的邮箱" v-model="data.email"></li>
      <li>
        <textarea placeholder="如您有其他疑问，可留言您的问题" @focus="inpFocus" @blur="inpBlur" v-model="data.memo"></textarea>
      </li>
    </ul>
    <button type="button" @click="postVal">提交</button>
  </div>
  <div class="pos-fixed" v-if="tipsFlag">提交成功</div>
</div>
</template>
<script>
export default {
  name: "contact",
  data: () => ({
    trialFlag: false,
    tipsFlag: false,
    data: {
      name: null,
      phone: null,
      company: null,
      email: null,
      memo: null
    },
    isCanScroll: false
  }),
  watch: {
    'isCanScroll' (value) {
      if (value) {
        document.querySelector("body").scrollIntoView();
      }
    }
  },
  methods: {
    postVal() {
      const _this = this;
      console.log(this.data);
      if (!this.data.name) {
        alert('请输入姓名')
        return
      }
      if (!this.data.phone) {
        alert('请输入电话')
        return
      }
      this.$axios({
          method: 'post',
          url: 'applications',
          params: {
            name: _this.data.name,
            phone: _this.data.phone || '#',
            company: _this.data.company || '#',
            email: _this.data.email || '#',
            memo: _this.data.memo || '#'
          }
        })
        .then(function() {
          _this.trialFlag = false;
          _this.tipsFlag = true;
          setTimeout(function() {
            _this.tipsFlag = false;
          }, 2000);
          _this.data = {
            name: null,
            phone: null,
            company: null,
            email: null,
            memo: null
          }
        })
    },
    inpFocus () {
      this.isCanScroll = false
    },
    inpBlur () {
      this.isCanScroll = true
    }
  }
}
</script>
<style lang="scss" scoped>
.contact {
    padding-bottom: 1.5rem;

    .pic {
        img {
            display: block;
            width: 28%;
            margin: 0 auto 15px;
        }
    }

    .content {
        background-color: #fff;
        border-radius: 4px;
        width: 7.1rem;
        margin: 0.15rem auto 0;
        padding: 0.3rem 0.2rem;
        box-sizing: border-box;
        text-align: center;
        box-shadow: 0 0 6px rgba(197, 205, 221, 1);

        p {
            font-size: 0.25rem;
            text-align: left;
            line-height: 0.45rem;
            padding-bottom: 0.1rem;
            color: #666;
        }
    }

    dl {
        padding: 0.4rem;

        dd {
            font-size: 0.22rem;
            color: #65696c;
            // text-align: center;
            line-height: 21px;
            margin: 0.2rem 0;
        }
    }

    .trial-button {
        width: 7.1rem;
        height: 0.72rem;
        line-height: 0.72rem;
        color: #fff;
        background-color: #3b5391;
        border: 0;
        display: block;
        font-size: 0.24rem;
        font-weight: 600;
        margin: 0 auto;
        border-radius: 4px;
        text-align: center;
        box-shadow: 0 0 3px rgba(0,0,0,0.4);
    }

    .messge {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.5);
        z-index: 1;
    }

    .carry {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 4px;
        box-shadow: 1px 1px 16px rgba(90,90,90,0.75);
        width: 85%;
        padding: 20px;
        box-sizing: border-box;
        background-color: #fff;
        text-align: center;
        z-index: 2;

        .colse {
            position: absolute;
            right: 0.6rem;
            top: 0.38rem;
            font-size: 0.4rem;
            color: #999;
        }

        h3 {
            font-size: 0.30rem;
            padding-bottom: 0.15rem;
        }

        li {
            margin: 5px 0;
        }

        input {
            box-sizing: border-box;
            border: 1px solid #ddd;
            height: 36px;
            line-height: 36px;
            width: 100%;
            text-indent: 0.5em;
            color: #666;
            border-radius: 4px;
        }
        textarea {
            box-sizing: border-box;
            border: 1px solid #ddd;
            height: 50px;
            width: 100%;
            color: #666;
            font-family: 'microsoft yahei';
            padding: 5px 0.5em;
            border-radius: 4px;
        }
        button {
            width: 100%;
            height: 0.7rem;
            line-height: 0.7rem;
            color: #fff;
            background-color: #3b5391;
            border: 0;
            display: block;
            font-size: 0.26rem;
            margin: 0 auto;
            border-radius: 4px;
            text-align: center;
            box-shadow: 0 0 3px rgba(0,0,0,0.4);
        }
    }
}
.pos-fixed {
  position: fixed;
  left: 50%;
  top: 50%;
  background-color: rgba(0,0,0,0.8);
  transform: translate(-50%, -50%);
  font-size: 0.6rem;
  line-height: 1.4rem;
  padding: 0 0.4rem;
  color: #fff;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/contact/index.vue